"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.deleteShiftAttribute = void 0;
const store_1 = __importDefault(require("../store"));
const is_loading_1 = __importDefault(require("./is-loading"));
const shift_attribute_delete_1 = __importDefault(require("../request/shift-attribute-delete"));
const load_workspace_detail_1 = __importDefault(require("@app/ac/load-workspace-detail"));
const create_ac_1 = require("./util/create-ac");
exports.deleteShiftAttribute = (0, create_ac_1.createAC)(async (dispatch, { attributeId }) => {
    const { workspaceId } = store_1.default.getState();
    if (!workspaceId || !attributeId)
        return;
    dispatch((0, is_loading_1.default)('delete-shift-attribute'));
    await (0, shift_attribute_delete_1.default)({
        id: attributeId,
        workspace: workspaceId
    });
    await dispatch((0, load_workspace_detail_1.default)(workspaceId));
    dispatch((0, is_loading_1.default)('delete-shift-attribute', true));
});
exports.default = exports.deleteShiftAttribute;
